// Components
import Button from '@components/UI-KIT/Button';
import Typography from '@components/UI-KIT/Typography';
import Modal from '@components/UI-KIT/Modal';

// Material ui
import { Grid } from '@material-ui/core';
import DateInput from '@/src/components/UI-KIT/Inputs/DateInput';
import { TransactionsFilters } from '@/src/services/account-transaction';

interface Props {
    openModal: boolean;
    disableModalButtons: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    downloadExcel: () => void;
    filters: TransactionsFilters;
    setFilters: React.Dispatch<React.SetStateAction<TransactionsFilters>>;
}

const DownloadAccountBalanceExcelModal: React.FC<Props> = ({
    openModal,
    filters,
    setFilters,
    disableModalButtons,
    setOpenModal,
    downloadExcel
}) => {

    return (
        <Modal
            title="Descargar balance de cuenta"
            open={openModal}
            className="AOL-contracts-list-rescind-contract"
            closeModal={() => setOpenModal(false)}
        >
            <Typography
                className="Typography-select-text-rescind"
            >
                Selecciona el periodo inicial
            </Typography>
            <DateInput
                periodInput
                value={filters.fromDate}
                onChange={value => setFilters({ ...filters, fromDate: value })}
                className="rescind-date-input"
            />
            <Typography
                className="Typography-select-text-rescind"
            >
                Selecciona el periodo final
            </Typography>
            <DateInput
                periodInput
                value={filters.toDate}
                onChange={value => setFilters({ ...filters, toDate: value })}
                className="rescind-date-input"
            />
            <Grid
                container
                justify="space-between"
            >
                <Button
                    level={2}
                    label="Cancelar"
                    disabled={disableModalButtons}
                    onClick={() => setOpenModal(false)}
                />
                <Button
                    errorColor
                    label="Confirmar"
                    disabled={disableModalButtons}
                    onClick={() => {
                        downloadExcel();
                        setOpenModal(false);
                    }}
                    loadingEvent
                />
            </Grid>
        </Modal>
    );
};

export default DownloadAccountBalanceExcelModal;